import { FieldActivity } from './fieldActivity';
import { FieldActivityProducts } from './fieldActivityProduct';

export class FieldActivityGrouped {
  type: string;
  uuid: string;
  ids: Array<number>;
  cropTotalSize: number;
  fieldIds: Array<number>;
  fieldNames: Array<string>;
  groupNames: Array<string>;
  productNames: Array<string>;
  userNames: Array<string>;
  tractorNames: Array<string>;
  equipmentNames: Array<string>;
  batchNames: Array<string>;
  activities: Array<FieldActivity>;
  commodityNames: Array<string>;
  cropIds?: Array<number>;
  machineActivities: boolean;
  activityDate: string;
  done: boolean;
  shapeFileTotal: number;
  verificationDate: string;
  verification: string;
  automaticActions: Array<string>;
  equipmentActivities?: Array<any>;
  productNamesWithDoseUsed?: Array<any>; //! DEPRECATED
  workedMinutesTotal: number;
  workedHectaresTotal: number;
  userForPipe?: Array<number>;
  note: string;
  title?: string;
  products?: Array<FieldActivityProducts>;

  constructor() {}
}
